import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import GUI from "lil-gui";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

/**
 * Base
 */
// Debug
const gui = new GUI();

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Lights
 */

const ambientLight = new THREE.AmbientLight(0xffffff, 0.9)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 2.1)
directionalLight.position.set(1, 1, 1)
scene.add(directionalLight)

/**
 * Objects
 */
const object1 = new THREE.Mesh(
  new THREE.SphereGeometry(0.5, 16, 16),
  new THREE.MeshBasicMaterial({ color: "#ff0000" }),
);
object1.position.x = -2;

const object2 = new THREE.Mesh(
  new THREE.SphereGeometry(0.5, 16, 16),
  new THREE.MeshBasicMaterial({ color: "#ff0000" }),
);

const object3 = new THREE.Mesh(
  new THREE.SphereGeometry(0.5, 16, 16),
  new THREE.MeshBasicMaterial({ color: "#ff0000" }),
);
object3.position.x = 2;

scene.add(object1, object2, object3);

/**
 * Radycaster
 */
const raycaster = new THREE.Raycaster();

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Cursor
 */
const cursor = new THREE.Vector2();
window.addEventListener("mousemove", (e) => {
  cursor.x = (e.clientX / sizes.width) * 2 - 1;
  cursor.y = -((e.clientY / sizes.height) * 2 - 1);
});

window.addEventListener("click", (e) => {
  if(currentIntersect !== null){
    console.log('clicked one')
  }
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100,
);
camera.position.z = 3;
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Models
 */
const loader = new GLTFLoader()

let duckModel = null
loader.load('/22-raycaster-and-mouse-events/models/Duck/glTF-Binary/Duck.glb', (gltf) => {
  duckModel = gltf.scene
  duckModel.position.y = -1.2
  scene.add(duckModel)
})

/**
 * Animate
 */
const clock = new THREE.Clock();

let currentIntersect = null;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  object1.position.y = Math.sin(elapsedTime * 0.3) * 1.5;
  object2.position.y = Math.sin(elapsedTime * 0.8) * 1.5;
  object3.position.y = Math.sin(elapsedTime * 1.4) * 1.5;

  // Cast a ray
  raycaster.setFromCamera(cursor, camera);

  // const rayOrigin = new THREE.Vector3(-3, 0, 0)
  // const rayDirection = new THREE.Vector3(1, 0, 0)

  // rayDirection.normalize()

  // raycaster.set(rayOrigin, rayDirection)

  const objectsToTest = [object1, object2, object3];
  const intersects = raycaster.intersectObjects(objectsToTest);

  for (const obj of objectsToTest) {
    if (intersects.some((intersect) => intersect.object === obj)) {
      obj.material.color.set("#00ff00");
    } else {
      obj.material.color.set("#ff0000");
    }
  }

  if (intersects.length) {
    const hoveredObject = intersects[0].object;
    if (currentIntersect !== hoveredObject) {
      console.log("mouse enter");
    }
    if (currentIntersect !== null && currentIntersect !== hoveredObject) {
      console.log("mouse leave");
    }
    currentIntersect = hoveredObject;
  } else {
    if (currentIntersect !== null) {
      console.log("mouse leave");
    }
    currentIntersect = null;
  }

  if(duckModel){
    let modelIntersects = duckModel && raycaster.intersectObject(duckModel)

    if(modelIntersects.length){
      duckModel.scale.set(1.2, 1.2, 1.2)
    } else {
      duckModel.scale.set(1, 1, 1)
    }
    // console.log(modelIntersects)
  }

  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
